class SearchForm extends HTMLElement {
	constructor() {
		super();
		this.input = this.querySelector('input[type="search"]');
		this.resetButton = this.querySelector('button[type="reset"]');
		this.predictiveSearch = this.querySelector(".predictive-search");

		if (this.input) {
			this.input.form.addEventListener("reset", this.onFormReset.bind(this));
			this.input.addEventListener(
				"input",
				debounce((event) => {
					this.onChange(event);
				}, 300).bind(this),
			);
		}
	}

	toggleResetButton() {
		const resetIsHidden = this.resetButton.classList.contains("hidden");
		if (this.input.value.length > 0 && resetIsHidden) {
			this.resetButton.classList.remove("hidden");
		} else if (this.input.value.length === 0 && !resetIsHidden) {
			this.resetButton.classList.add("hidden");
		}
	}

	onChange() {
		this.toggleResetButton();
	}

	shouldResetForm() {
		return !document.querySelector('[aria-selected="true"] a');
	}

	onFormReset(event) {
		// Prevent default so the form reset doesn't set the value gotten from the url on page load
		event.preventDefault();
		// Don't reset if the user has selected an element on the predictive search dropdown
		if (this.shouldResetForm()) {
			const searchModal = document.querySelector(".search-modal");
			const headerIconContainer =
				document.querySelector(".header__search").parentElement;
			const details = headerIconContainer.querySelector("details");
			this.input.value = "";
			this.input.focus();
			this.toggleResetButton();
			this.predictiveSearch.classList.add("!hidden");
			searchModal.classList.add("hidden");
			details.removeAttribute("open");
			headerIconContainer.style.position = "relative";
		}
	}
}

customElements.define("search-form", SearchForm);
